import { wordpressImgToImgixURL } from 'Utilities';

const YOUTUBE_ID_PATTERN = /^[\w-]{11}$/;

export const getYouTubeVideoId = (url?: string): string | null => {
  if (!url) {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const host = parsed.hostname.replace(/^www\./, '');

  if (host === 'youtu.be') {
    const id = parsed.pathname.slice(1);
    return YOUTUBE_ID_PATTERN.test(id) ? id : null;
  }

  if (host === 'youtube.com' || host === 'youtube-nocookie.com' || host === 'm.youtube.com') {
    const watchId = parsed.searchParams.get('v');
    if (watchId && YOUTUBE_ID_PATTERN.test(watchId)) {
      return watchId;
    }

    const embedMatch = parsed.pathname.match(/^\/(?:embed|shorts|v)\/([\w-]{11})/);
    if (embedMatch) {
      return embedMatch[1];
    }
  }

  return null;
};

export const getYouTubeEmbedUrl = (url?: string): string | null => {
  const id = getYouTubeVideoId(url);
  return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
};

const IMAGE_RENDERED_WIDTH = 480 * 2;

export const toImageSrc = (url: string): string => {
  const imgixUrl = wordpressImgToImgixURL(url);

  return imgixUrl !== url ? `${imgixUrl}&w=${IMAGE_RENDERED_WIDTH}` : imgixUrl;
};
